import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { PlatformFeatureType } from '@conversed/shared/src/central/types/platform-features.type';
import {
  StudioType,
  TRAIN_AI_PAGE_STUDIO_TYPES,
} from '@conversed/shared/src/central/types/studio.type';

import {
  ACTIVITY_LOGS_PAGE_ROUTE,
  AI_KNOWLEDGE_HUB_PAGE_ROUTE,
  ARTICLE_ARCHITECT_PAGE_ROUTE,
  CHAT_PAGE_ROUTE,
  CONFIGURATION_PAGE_ROUTE,
  DASHBOARD_PAGE_ROUTE,
  DESIGNER_PAGE_ROUTE,
  EDIT_APPEARANCE_PAGE_ROUTE,
  EXPORTS_PAGE_ROUTE,
  GDPR_PAGE_ROUTE,
  HOME_PAGE_ROUTE,
  INTEGRATIONS_PAGE_ROUTE,
  PREVIEW_PAGE_ROUTE,
  REPORTS_PAGE_ROUTE,
  TEST_ACCURACY_PAGE_ROUTE,
  TRAIN_AI_PAGE_ROUTE,
  USERS_PAGE_ROUTE,
} from '../../constants/routes';
import type { ISideBarRouting } from '../../interfaces/ISidebar';

export const SidebarRoutes: ISideBarRouting[] = [
  {
    text: 'sidebar.item.home',
    permissions: [],
    studioTypes: [], // Available in all studios
    to: HOME_PAGE_ROUTE,
    icon: 'home',
  },
  {
    text: 'sidebar.item.dashboard',
    permissions: [PERMISSIONS.DASHBOARD.DASHBOARD_VIEW],
    studioTypes: [],
    to: DASHBOARD_PAGE_ROUTE,
    icon: 'insights',
    hiddenWhenFeatureActive: PlatformFeatureType.HomeV2,
  },
  {
    text: 'sidebar.item.train-ai',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_VIEW],
    studioTypes: TRAIN_AI_PAGE_STUDIO_TYPES,
    icon: 'build',
    to: TRAIN_AI_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.preview',
    permissions: [PERMISSIONS.WEBCLIENT.WEBCLIENT_PREVIEW],
    studioTypes: [
      StudioType.CHAT_AI,
      StudioType.EMAIL_AI,
      StudioType.TICKET_AI,
    ],
    icon: 'sms',
    to: PREVIEW_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.voice-preview',
    permissions: [PERMISSIONS.WEBCLIENT.WEBCLIENT_PREVIEW],
    studioTypes: [StudioType.VOICE_AI],
    icon: 'voice_chat',
    to: PREVIEW_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.data-sources',
    permissions: [PERMISSIONS.DATA_SOURCE.DATA_SOURCE_LIST],
    studioTypes: [],
    icon: 'memory',
    to: AI_KNOWLEDGE_HUB_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.article-architect',
    permissions: [PERMISSIONS.DATA_SOURCE.ARTICLE_ARCHITECT_VIEW],
    studioTypes: [],
    icon: 'auto_awesome',
    to: ARTICLE_ARCHITECT_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.integrations',
    permissions: [PERMISSIONS.INTEGRATIONS.INTEGRATIONS_VIEW],
    studioTypes: [],
    icon: 'hub',
    to: INTEGRATIONS_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.styling',
    permissions: [
      PERMISSIONS.WEBCLIENT.WEBCLIENT_CONFIG_LIST,
      PERMISSIONS.WEBCLIENT.WEBCLIENT_CONFIG_EDIT,
    ],
    studioTypes: [
      StudioType.CHAT_AI,
      StudioType.EMAIL_AI,
      StudioType.TICKET_AI,
      StudioType.VOICE_AI,
    ],
    icon: 'palette',
    to: EDIT_APPEARANCE_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.configuration',
    permissions: [PERMISSIONS.WEBCLIENT.WEBCLIENT_CONFIG_LIST],
    studioTypes: [],
    icon: 'rocket_launch',
    to: CONFIGURATION_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.users',
    permissions: [PERMISSIONS.COMPANY.COMPANY_MEMBERS_MANAGE],
    studioTypes: [],
    icon: 'manage_accounts',
    to: USERS_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.livechat',
    permissions: [PERMISSIONS.CONVERSATION.CONVERSATION_MANAGE],
    studioTypes: [StudioType.CHAT_AI],
    icon: 'support_agent',
    to: CHAT_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.flow-builder',
    permissions: [PERMISSIONS.FLOW.FLOW_LIST],
    studioTypes: [
      StudioType.CHAT_AI,
      StudioType.EMAIL_AI,
      StudioType.TICKET_AI,
    ],
    icon: 'account_tree',
    to: DESIGNER_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.export-center',
    permissions: [PERMISSIONS.EXPORTS.EXPORT_LIST],
    studioTypes: [StudioType.CHAT_AI],
    icon: 'file_download',
    to: EXPORTS_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.privacy-and-data',
    permissions: [PERMISSIONS.GDPR.GDPR_LIST],
    studioTypes: [StudioType.CHAT_AI],
    icon: 'privacy_tip',
    to: GDPR_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.conversations-reports',
    permissions: [PERMISSIONS.REPORTING.REPORTING_VIEW],
    studioTypes: [StudioType.CHAT_AI],
    icon: 'assessment',
    to: REPORTS_PAGE_ROUTE,
  },
  {
    text: 'sidebar.item.logs',
    permissions: [PERMISSIONS.LOGS.VIEW_LOGS],
    studioTypes: [StudioType.CHAT_AI],
    to: ACTIVITY_LOGS_PAGE_ROUTE,
    icon: 'list_alt',
  },
  {
    text: 'sidebar.item.test-accuracy',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    studioTypes: [
      StudioType.CHAT_AI,
      StudioType.EMAIL_AI,
      StudioType.TICKET_AI,
    ],
    to: TEST_ACCURACY_PAGE_ROUTE,
    icon: 'smart_toy',
  },
];
